module.exports = __webpack_public_path__ + "img/art.12cb6025.svg";